import React from 'react';

function Checkbox({ classNames, checked, label, onChange, name, register, disabled = false }) {
  return (
    <div className={classNames}>
      <input
        data-cy={name}
        id={name}
        className='custom__checkbox ml-2 self-center'
        type='checkbox'
        name={name}
        {...register(name)}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      {label && (
        <label style={{ width: '100%' }} htmlFor={name}>
          {label}
        </label>
      )}
    </div>
  );
}

export default React.memo(Checkbox);
